
export default {
  props: {
    icon: { type: String, default: 'mdi-dots-vertical' }
  }
}
